/* RESPONSIBLE TEAM: unused-components */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
/* eslint-disable ember/require-computed-property-dependencies */
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import AttributeComponent from 'embercom/components/attribute-component';
import B64FilterParamEncoder from 'embercom/vendor/intercom/b64-filter-param-encoder';

let SimpleSegmentComponent = AttributeComponent.extend({
  value: alias('segment.name'),
  filterUrl: computed('userOrCompany', 'attribute', 'segment.predicate', function () {
    return B64FilterParamEncoder.filterUrlFromPredicates(
      this.userOrCompany,
      this.get('segment.predicates'),
    );
  }),
});

export default SimpleSegmentComponent;
